// Same base URL as apiClient (REACT_APP_API_URL), without a trailing slash
const API_BASE_URL = (process.env.REACT_APP_API_URL || 'https://api.datum-games.com').replace(/\/+$/, '');

const ASSETS_PREFIX = '/v1/assets/';

/**
 * Images uploaded through the admin panel are stored in `game_assets` and referenced
 * by a relative API path (`/v1/assets/{uuid}`) — those must be loaded from the API host.
 * Everything else (`/lair/castle.svg` from public/, absolute URLs) is returned as is.
 */
export function resolveAssetUrl(url) {
  if (!url || typeof url !== 'string') return url ?? null;
  if (url.startsWith(ASSETS_PREFIX)) return `${API_BASE_URL}${url}`;
  return url;
}

export default resolveAssetUrl;
